import { HIDE_NAV_MENU,  SHOW_NAV_MENU} from "./showNavMenuReducer"

export const hideNavMenu = () => ({
    type: HIDE_NAV_MENU,
})

export const showNavMenu = () => ({
    type: SHOW_NAV_MENU,
})